const styles = (theme) => ({
  card: {
    ...theme.card.card,
    cursor: 'pointer',
    backgroundColor: '#F5F6F8',
    margin: '0px 24px 0px 0px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.06)',
    [theme.breakpoints.down('sm')]: {
      margin: '12px 12px 0px 0px',
    },
  },
  card_content: {
    ...theme.card.card_content,
    padding: '24px 0px 18px 12px',
    [theme.breakpoints.down('sm')]: {
      padding: '12px',
      height: '43px',
    },
  },
  main_text_container: {
    padding: '5px 0 0 25px',
  },
  main_title_green: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: theme.palette.primary.main,
  },
  main_title_grey: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: theme.texts.secondary,
  },
  hello_subtitle: {
    margin: '20px 0px',
    color: '#565656',
    fontSize: '1.125rem',
  },
  coupon_text: {
    marginTop: '0px',
    color: '#565656',
    textAlign: 'center',
    fontSize: '0.875rem',
  },
  coupon_link: {
    textAlign: 'center',
    color: '#53B755',
  },
  stat_container: {
    marginTop: '20px',
  },
  stat_title: {
    margin: 0,
    fontWeight: '400',
    lineHeight: '14px',
    color: '#A5A5A5',
    fontSize: '0.75rem',
    textDecoration: 'none',
    [theme.breakpoints.down('sm')]: {
      height: '28px',
    },
  },
  stat_subtitle: {
    margin: 0,
    fontWeight: '400',
    lineHeight: '28px',
    color: '#383838',
    fontSize: '18px',
    textDecoration: 'none',
    [theme.breakpoints.down('sm')]: {
      marginTop: '6px',
    },
  },
  metric_title: {
    fontWeight: '400',
    fontSize: '1.12rem',
    lineHeight: '24px',
    margin: '0px 0px 24px 0px',
  },
});

export default styles;
